export default {
    //R
    account:{
        /*=== add-label.vue ====*/
        trading_account_label: "เพิ่มป้ายกำกับในบัญชีการเทรดของคุณเรียบร้อยแล้ว",
        ok: "ตกลง",
        add_account_label: "เพิ่มป้ายกำกับบัญชี",
        trading_account: "บัญชีการเทรด",
        select_trading_id: "เลือกรหัสการเทรด",
        label: "ป้ายกำกับ",
        alpha_numeric_characters : "กำหนดป้ายกำกับให้กับบัญชีของคุณ: (ตัวอักษรและตัวเลขไม่เกิน 15 ตัว)",
        apply: "ปรับใช้",
        cancel: "ยกเลิก",
        
        /*=== change-acct-leverage.vue ====*/
        request_change_laverage: "เราได้รับคำขอเปลี่ยนแปลงเลเวอเรจของรหัสการเทรดของคุณแล้ว",
        from :"จาก",
        to :"ถึง",
        confirm_mail_id:"เพื่อยืนยัน กรุณาคลิกลิงก์ยืนยันที่ส่งไปยังรหัสอีเมลที่คุณลงทะเบียน",
        leverage_successfully_change:"ประมวลผลคำขอเปลี่ยนเลเวอเรจสำเร็จแล้ว",
        change_account_leverage:"เปลี่ยนเลเวอเรจของบัญชี",
        select_trading_account :"เลือกบัญชีเทรด",
        existing_leverage :"เลเวอเรจที่มีอยู่",
        new_leverage :"เลเวอเรจใหม่",
        select_new_leverage :"เลือกเลเวอเรจใหม่",
        change_leverage:"เปลี่ยนเลเวอเรจ",
        account_leverage_reduced :"หากเลเวอเรจของบัญชีลดลงจากเลเวอเรจปัจจุบัน จะเป็นการเพิ่มมาร์จิ้นที่ใช้สำหรับการเทรดที่เปิดอยู่ของคุณ (หากมี)",
        
        /*=== create-account.vue ====*/
        mandatory_complete_KYC:"จำเป็นต้องกรอก KYC ก่อนสร้างบัญชีจริงมากกว่าหนึ่งบัญชี",
        submit_proof_address:"กรุณาส่งหลักฐานที่อยู่โดยใช้ตั๋วสนับสนุน",
        click_here:"คลิกที่นี่",
        email_to: "หรือส่งอีเมลมาที่",
        contactus_aaafx_com :"contactus{'@'}aaafx.com",
        following_address_Proofs: "หลักฐานที่อยู่ต่อไปนี้ได้รับการยอมรับ:",
        utility_bill: "บิลค่าสาธารณูปโภค",
        bank_statement: "รายการเงินฝากถอนในบัญชี",
        government_issued:"เอกสารภาษีที่ออกโดยรัฐบาล",
        note:"หมายเหตุ",
        proof_of_address:"หลักฐานที่อยู่จะต้องมีอายุไม่เกิน 4 เดือน",
        account :"บัญชี",
        select_platform:"เลือกแพลตฟอร์ม",
        select_account_type:"เลือกประเภทบัญชี",
        connect_your_account:"คุณต้องการเชื่อมต่อบัญชีของคุณกับ ZuluTrade หรือไม่?",
        select_leverage:"เลือกเลเวอเรจ",
        select_account_base_currency:"เลือกสกุลเงินฐานของบัญชี",
        select_currency:"เลือกสกุลเงิน",
        Password:"รหัสผ่าน",
        minimum_password_length5:"ความยาวของรหัสผ่านขั้นต่ำ คือ 5 ตัวอักษรและต้องมีตัวพิมพ์เล็กอย่างน้อย 1 ตัว ตัวพิมพ์ใหญ่ 1 ตัว ตัวเลข 1 ตัว และอักขระพิเศษ 1 ตัว",
        minimum_password_length8:"ความยาวของรหัสผ่านขั้นต่ำ คือ 8 ตัวอักษรและต้องมีตัวอักษรพิมพ์เล็กอย่างน้อย 1 ตัว ตัวพิมพ์ใหญ่ 1 ตัว ตัวเลข 1 ตัว และอักขระพิเศษ 1 ตัว",
        spcl_characters:"จำนวนของอักขระ",
        lowercase_letter:"ตัวอักษรพิมพ์เล็ก",
        capital_letter:"ตัวอักษรพิมพ์ใหญ่",
        number: "หมายเลข",
        special_character:"อักขระพิเศษ",
        confirm_password :"ยืนยันรหัสผ่าน",
        trade_With_virtual_funds:"เทรดด้วยเงินเสมือนจริง",
        test_strategies:"ทดสอบกลยุทธ์ฟรี",
        risk_free_trading:"การเทรดที่ไม่มีความเสี่ยง",
        live_market_feed: "ฟีดตลาดสด",
        liquidity_from_top :"สภาพคล่องจาก LP ชั้นนำ",
        effective_trading:"เครื่องมือการเทรดที่มีประสิทธิภาพ",
        instant_execution:"การดำเนินการทันที",
        low_commissions:"ค่าคอมมิชชันและสเปรดต่ำ",
        create_new:"สร้างใหม่",
        
        /*=== enable-2fa.vue ====*/
        enable_2fa: "เปิดใช้งานการตรวจสอบสิทธิ์แบบ 2 ปัจจัย",
        click_to_enable: "คลิกเพื่อเปิดใช้งาน",
        
        /*=== internal-transfer.vue ====*/
        received_your_request:"เราได้รับคำขอโอนเงินของคุณแล้ว",
        from_trading_account:"จากบัญชีเทรด",
        to_confirm:"เพื่อยืนยัน กรุณาคลิกลิงก์ยืนยันที่ส่งไปยังรหัสอีเมลที่คุณลงทะเบียน",
        internal_transfer_request:"คำขอโอนเงินภายในของคุณจากบัญชี",
        for_amount:"สำหรับจำนวน",
        to_account:"ถึงบัญชี",
        was_succesfull :"สำเร็จด้วยจำนวน",
        internal_transfer: "โอนภายใน",
        transfer_From: "โอนจาก",
        transfer_to:"โอนถึง",
        balance: "ยอดคงเหลือ",
        enter_amount: "กรอกจำนวนเงิน",
        USE_MAX:"ใช้สูงสุด",
        proceed:"ดำเนินการต่อ",
        Internal_Transfer_ZIP:"การโอนภายในไม่พร้อมใช้งานสำหรับบัญชี ZTP",
        In_case_of_internal_transfer:"หมายเหตุ: ในกรณีของการโอนภายในระหว่างบัญชีที่มีฐานสกุลเงินต่างกัน จำนวนเงินที่โอนจะเป็นไปตามราคาตลาดที่แพร่หลาย",
        
        /*=== manage-account.vue ====*/
        attention :"โปรดทราบ - คุณกำลังจะขอลบรหัสการเทรด",
        note_after_requesting:"หมายเหตุ: - หลังจากส่งคำขอแล้ว บัญชีของคุณจะถูกลบออกจากบันทึกและคุณจะไม่สามารถกู้คืนได้",
        after_clicking:"หลังจากคลิกที่ปุ่มยืนยัน คุณจะได้รับลิงก์ยืนยันในรหัสอีเมลที่ลงทะเบียนเพื่อลบบัญชีเทรดของคุณ",
        currency: "สกุลเงิน",
        Account_Type: "ประเภทบัญชี",
        Account_Label: "ป้ายกำกับบัญชี",
        Bonus: "โบนัส",
        Leverage: "เลเวอเรจ",
        Equity: "เงินทุน",
        Create_Demo_Account: "สร้างบัญชีทดลอง",
        Create_Live_Account :"สร้างบัญชีจริง",
        internal_transfer_CAP:"การโอนภายใน",
        web_trading:"เว็บเทรด",
        add_account_label_CAP:"เพิ่มป้ายกำกับบัญชี",
        change_laverage:"เปลี่ยนเลเวอเรจ",
        delete_account:"ลบบัญชี",
        reset_trading_password:"รีเซ็ตรหัสผ่านการเทรด",
        
        verifying_your_request: "กำลังตรวจสอบคำขอของคุณ...",
        success: "สำเร็จ",
        error: "ข้อผิดพลาด",
        
        /*=== operations-verify.vue ====*/
        we_have_received_your_request :"เราได้รับคำขอรีเซ็ตรหัสผ่านนักลงทุนของคุณแล้ว เพื่อยืนยัน กรุณาคลิกลิงก์ยืนยันที่ส่งไปยังรหัสอีเมลที่คุณลงทะเบียน",
        change_investor_password:"เปลี่ยนรหัสผ่านนักลงทุนสำเร็จ",
        reset_investor_password:"รีเซ็ตรหัสผ่านนักลงทุน",
        investor_password:"รหัสผ่านนักลงทุน",
        master_password:"รหัสผ่านหลัก",
        trading_iD: "รหัสการเทรด",
        enter_new_password:"ป้อนรหัสผ่านใหม่",
        confirm_new_password :"ยืนยันรหัสผ่านใหม่",
        password_must_contain:"รหัสผ่านของคุณต้องมีขั้นต่ำ 6 อักขระและสูงสุด 10 อักขระ ตัวเลขอย่างน้อย 1 ตัว อักขระตัวพิมพ์ใหญ่ 1 ตัว และอักขระพิเศษ 1 ตัว (!@$%*)",
        change_Password:"เปลี่ยนรหัสผ่าน",
        
        /*=== reset-investor-pass.vue ====*/
        reset_master_password:"รีเซ็ตรหัสผ่านหลัก",
        click_reset:"คลิกที่นี่เพื่อรีเซ็ต",
        password_caption:"รหัสผ่านนักลงทุนเป็นรหัสผ่านแบบอ่านอย่างเดียว ซึ่งไม่อนุญาตให้ผู้ใช้เทรด หากคุณเข้าสู่ระบบโดยใช้รหัสผ่านหลัก คุณจะได้รับสิทธิ์การเข้าถึงและสิทธิ์การเทรดในบัญชีอย่างเต็มรูปแบบ",
    },
    auth: {
        /*=== corporate.vue ====*/
        corporate: "องค์กร",
        account_type: "ประเภทบัญชี",
        select_account_type: "เลือกประเภทบัญชี",
        individual: "บุคคล",
        name_of_company: "ชื่อของบริษัท",
        country_of_company: "ประเทศของบริษัท",
        select_company_country: "เลือกประเทศของบริษัท",
        registration: "การลงทะเบียน",
        email_company: "อีเมลของบริษัท",
        Password: "รหัสผ่าน",
        min_password_length8: "ความยาวขั้นต่ำของรหัสผ่านคือ 8 ตัวและต้องมีอักษรตัวพิมพ์เล็กอย่างน้อย 1 ตัว ตัวพิมพ์ใหญ่ 1 ตัว ตัวเลข 1 ตัว และอักขระพิเศษ 1 ตัว",
        spcl_characters: "จำนวนของตัวอักษร",
        lowercase_letter: "ตัวอักษรพิมพ์เล็ก",
        capital_letter: "ตัวอักษรพิมพ์ใหญ่",
        number: "หมายเลข",
        special_character: "อักขระพิเศษ",
        confirm_password: "ยืนยันรหัสผ่าน",
        Phone_Number: "หมายเลขโทรศัพท์",
        have_read: "ฉันได้อ่าน ทำความเข้าใจ และยอมรับแล้ว",
        terms_conditions: "ข้อกำหนดและเงื่อนไข",
        accept_terms_conditions: "กรุณายอมรับข้อกำหนดและเงื่อนไข",
        given_your_residency: "ตามถิ่นที่อยู่อาศัยของคุณ คุณจะได้รับบริการ Triple A Experts Investment Services (GR) ที่กำกับดูแลโดย HCMC คุณสามารถดูความคุ้มครอง และข้อกำหนดและเงื่อนไขได้ที่เว็บไซต์ของเรา เมื่อคลิก ",
        continue: "ดำเนินการต่อ",
        triple_investment_services: "ถือว่าคุณตกลงที่จะเปิดบัญชีของคุณกับ Triple A Experts Investment Services (GR)",
        register: "ลงทะเบียน",
        already_have_account: "มีบัญชีอยู่แล้ว?",
        login: "เข้าสู่ระบบ",
        /*=== forgot-password.vue ====*/
        confirmation_link: "ระบบได้ส่งลิงก์ยืนยันไปยังรหัสอีเมลที่ลงทะเบียนของคุณแล้ว กรุณาคลิกที่ลิงก์เพื่อรีเซ็ตรหัสผ่านเข้าสู่ระบบของคุณ",
        ok: "ตกลง",
        this_email_address: "อีเมลนี้ไม่ได้ลงทะเบียนกับเรา",
        click_here: "คลิกที่นี่",
        create_account_now: "เพื่อสร้างบัญชีตอนนี้",
        forgot_password: "ลืมรหัสผ่าน",
        email_address: "อีเมล",
        submit: "ส่ง",
        dont_have_account: "ไม่มีบัญชี?",
        create_account_now_CAP: "สร้างบัญชีตอนนี้!",
        /*=== login.vue ====*/
        client_login: "เข้าสู่ระบบลูกค้า",
        remember_me: "จดจำฉัน",
        two_step_verification: "การยืนยันสองขั้นตอน",
        google_authenticator: "กรุณากรอกรหัสผ่านแบบใช้ครั้งเดียวที่แสดงในแอป Google Authenticator",
        google_auth_code: "รหัส Google Auth",
        /*=== register.vue ====*/
        sent_an_OTP: "เราได้ส่ง OTP ไปที่",
        complete_your_registration: "กรุณากรอกเพื่อยืนยันและลงทะเบียนให้เสร็จสมบูรณ์",
        otp: "OTP",
        Register_heading: "ลงทะเบียน",
        first_name: "ชื่อจริง",
        last_name: "นามสกุล",
        email: "อีเมล",
        country: "ประเทศ",
        select_residence_country: "เลือกประเทศที่อยู่อาศัย",
        privacy_policy: "นโยบายความเป็นส่วนตัว",
        accept_privacy_policy: "กรุณายอมรับนโยบายความเป็นส่วนตัว",
        experts_investment_services: "ตามถิ่นที่อยู่อาศัยของคุณ คุณจะได้รับบริการ Triple A Experts Investment Services (GR) ที่กำกับดูแลโดย HCMC คุณสามารถดูความคุ้มครอง และข้อกำหนดและเงื่อนไขได้ที่เว็บไซต์ของเรา เมื่อคลิก ",
        opening_your_account: "ถือว่าคุณตกลงที่จะเปิดบัญชีของคุณกับ Triple A Experts Investment Services (GR)",
        /*=== reset-password.vue ====*/
        login_password_change: "เปลี่ยนรหัสผ่านเข้าสู่ระบบของคุณสำเร็จแล้ว",
        reset_password: "รีเซ็ตรหัสผ่าน",
        reset: "รีเซ็ต",
    },
    //H
    copy_trading: {
        copy_trading: "คัดลอกการเทรด",
        copy_trading_header: "รับผลกำไรโดยคัดลอกการเทรดของผู้จัดการกลยุทธ์โดยอัตโนมัติ",
        leading_traders: "คัดลอกนักเทรดผู้นำโดยอัตโนมัติ",
        diversified_trading: "พอร์ตโฟลิโอการเทรดที่หลากหลาย",
        monitor_profit: "ตรวจสอบและกำไร",
        copy_traders: "จะคัดลอกการเทรดได้อย่างไร?",
        one: "1.",
        one_header: "เปิดบัญชีจริงและทำการฝากเงิน",
        two: "2.",
        two_header: "เลือกผู้จัดการกลยุทธ์",
        three: "3.",
        three_header: "ยอมรับข้อตกลงและเงื่อนไข",
        four: "4.",
        four_header: "มอบข้อตกลงของคุณให้เราทราบ",
        five: "5.",
        five_header: "รับผลกำไรด้วยการคัดลอกการเทรด",
        order_processing: "การประมวลผลคำสั่งซื้ออย่างรวดเร็ว",
        end_result: "ควบคุมผลลัพธ์สุดท้าย",
        trading_skills: "อัปเกรดทักษะการเทรดของคุณ",
        start: "เริ่มต้น"
    },
    downloads: {
        mt_four_desktop: "MT4 Desktop",
        mt_four_android: "MT4 Android",
        mt_four_ios: "MT4 iOS",
        mt_four_web_trader: "MT4 Web Trader",
        mt_five_desktop: "MT5 Desktop",
        mt_five_android: "MT5 Android",
        mt_five_ios: "MT5 iOS",
        mt_five_web_trader: "MT5 Web Trader",
        act_trader_desktop: "Act Trader Desktop",
        act_trader_android: "Act Trader Android",
        act_trader_ios: "Act Trader iOS",
        act_web_trader: "Act Web Trader"
    },
    tools_index: {
        avail_vps: "คุณแน่ใจหรือไม่ว่าต้องการใช้ VPS?",
        package: "แพ็กเกจ?",
        yes: "ใช่",
        no: "ไม่ใช่",
        downloads: "ดาวน์โหลด",
        copy_trading: "คัดลอกการเทรด",
        vps: "VPS"
    },
    vps: {
        vps_plans: "แผน VPS",
        bronze: "บรอนซ์",
        monthly_subscription_twenty_five: "การสมัครสมาชิกรายเดือน 25 ดอลลาร์",
        free_deposit_five_thousand: "รับฟรีเมื่อฝากเงิน 5,000 ดอลลาร์ขึ้นไป",
        compatible_mt_four_five_act: "ใช้งานได้กับ MT4, MT5 และ Act",
        free_twenty_five_gb_disk_space_ram_vcpu: "พื้นที่ว่างในดิสก์ 25 GB ฟรี | แรม 1300 MB | 1 VCPU",
        windows_linux_support: "Windows 8/10/12 รองรับ Linux",
        avail_now: "มีให้บริการตอนนี้",
        silver: "ซิลเวอร์",
        monthly_subscription_fourty_five: "การสมัครสมาชิกรายเดือน 45 ดอลลาร์",
        free_on_deposit_ten_thousand: "รับฟรีเมื่อฝากเงิน 10,000 ดอลลาร์ขึ้นไป",
        free_fifty_gb_disk_space_ram_vcpu: "พื้นที่ว่างในดิสก์ 50 GB ฟรี | แรม 2700 MB | 2 VCPU",
        gold: "โกลด์",
        monthly_subscription_eighty: "การสมัครสมาชิกรายเดือน 80 ดอลลาร์",
        free_on_deposit_fifteen_thousand: "รับฟรีเมื่อฝากเงิน 15,000 ดอลลาร์ขึ้นไป",
        free_seventy_five_gb_disk_space_ram_vcpu: "Free 75 GB Disk Space | 5120 MB RAM | 3 VCPU"
    },
    ticket_details: {
        cancel_withdrawal_request: "ยกเลิกคำขอถอนเงิน",
        cancel_your_withdrawal_request: "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกคำขอถอนเงินของคุณ",
        process_request: "ดำเนินการตามคำขอ",
        open_tickets: "เปิดตั๋ว",
        back: "ย้อนกลับ",
        ticket_number: "หมายเลขตั๋ว:",
        created: "สร้างเมื่อ:",
        reason: "เหตุผล:"
    },
    bonus: {
        request_to_avail_bonus: "คำขอของคุณเพื่อรับโบนัสของ",
        trading_id: "สำหรับรหัสการเทรด",
        click_confirmation_link: "ได้รับการตอบรับ เพื่อยืนยัน กรุณาคลิกที่ลิงก์ยืนยันที่ส่งไปยังรหัสอีเมลที่ลงทะเบียนของคุณ",
        request_to_remove_bonus: "คำขอของคุณที่จะลบโบนัสของ",
        bonus_amount: "จำนวนโบนัสของคุณ",
        successfully_removed_account: "ถูกลบออกจากรหัสบัญชีเรียบร้อยแล้ว",
        ok: "ตกลง",
        request_to_add_bonus: "คำขอของคุณเพื่อเพิ่มโบนัสของ",
        successfully: "สำเร็จแล้ว",
        bonus: "โบนัส",
        select_trading_id: "เลือกรหัสการเทรด",
        use_max: "ใช้งานสูงสุด",
        account_type: "ประเภทบัญชี",
        equity: "เงินทุน",
        leverage: "เลเวอเรจ",
        currency: "สกุลเงิน",
        current_bonus: "โบนัสปัจจุบัน",
        allowed_bonus: "โบนัสที่ได้รับอนุญาต",
        remove: "ลบออก",
        account_first: "กรุณาเลือกบัญชีก่อน",
        bonus_amount_base_currency: "หมายเหตุ: กรอกจำนวนโบนัสในสกุลเงินหลัก",
        point_one: "1. ข้อเสนอโบนัส 100% ของเรามีให้สำหรับลูกค้าทุกคนที่ฝากเงินขั้นต่ำ 100 ดอลลาร์สหรัฐ และเลเวอเรจในบัญชีสูงถึง 1:200 โบนัสสูงสุดที่อนุญาตคือ 40,000 ดอลลาร์สหรัฐต่อลูกค้าหนึ่งราย",
        point_two: "2. กำไรที่ได้รับจากการเทรดโดยโบนัสของเราจะเป็นของคุณทั้งหมด โบนัสจะไม่ถูกนำออกหากคุณถอนผลกำไรของคุณ",
        point_three: "3. โบนัสช่วยเพิ่มมาร์จิ้นที่มีอยู่ในบัญชี อย่างไรก็ตาม การขาดทุนของคุณไม่สามารถรวมเป็นโบนัสได้ หากการขาดทุนทั้งหมดในการเทรดของคุณเกินเงินทุนของคุณ ระบบจะปิดโพสิชันในบัญชีการเทรดของคุณโดยอัตโนมัติโดยไม่ต้องแจ้งให้ทราบล่วงหน้า",
        point_four: "4. จำนวนโบนัสตามสัดส่วนจะถูกลบออกจากบัญชีของคุณ หากคุณทำการถอนเงินของคุณเอง",
        read_understood_accepted: "ฉันได้อ่าน ทำความเข้าใจ และยอมรับแล้ว",
        aaafx_bonus_policy: "นโยบายโบนัส AAAFx",
        accept_aaafx_bonus_policy: "กรุณายอมรับนโยบายโบนัส AAAFx",
        proceed: "ดำเนินการต่อ",
        no_bonus_available_account: "ไม่มีโบนัสสำหรับบัญชีนี้"
    },
    refer_earn: {
        bonus: "โบนัส",
        refer_earn: "แนะนำและรับเงิน",
        refer_friend: "แนะนำเพื่อน",
        earn_dollar_twenty_five: "รับเงิน 25 ดอลลาร์",
        per_friend: "ต่อเพื่อนหนึ่งคน",
        why_refer_someone_to_us: "เพราะเหตุใดคุณควรแนะนำใครสักคนให้กับเรา?",
        refer_someone_point_one: "1. คุณและเพื่อนของคุณได้รับประโยชน์จากโบนัสการแนะนำ",
        refer_someone_point_two: "2. ขั้นตอนที่ตรงไปตรงมาและรวดเร็ว",
        refer_someone_point_three: "3. คุณทั้งคู่ได้รับประโยชน์จากเงื่อนไขการเทรดที่เป็นไปในเชิงบวก",
        refer_someone_point_four: "4. รายได้จากการแนะนำนั้นไม่มีขีดจำกัด",
        what_need_to_do: "นี่คือสิ่งที่คุณต้องทำ:",
        what_need_to_do_point_one: "1. แชร์ลิงก์แนะนำของคุณกับเพื่อนของคุณ",
        what_need_to_do_point_two: "2. คนที่คุณแนะนำลงทะเบียนโดยใช้ลิงก์ของคุณและเริ่มต้นการเทรด",
        what_need_to_do_point_three: "3. ทันทีที่คนที่คุณแนะนำมีคุณสมบัติ คุณทั้งคู่จะได้รับคนละ 25 ดอลลาร์",
        referral_list: "รายชื่อการเชิญเพื่อนของคุณ"
    },
    referral_list: {
        referrals_list: "รายชื่อที่แนะนำ",
        list_of_referrals: "รายชื่อที่แนะนำเพื่อติดตามรายได้ของคุณ",
        s_no: "S.No.",
        name: "ชื่อ",
        email_id: "รหัสอีเมล",
        account_stage: "ขั้นตอนของบัญชี",
        deposits: "เงินฝาก",
        volume_required: "วอลุ่มที่ต้องการ",
        traded_volume: "วอลุ่มการเทรด",
        qualified: "มีคุณสมบัติ",
        no_data: "ไม่มีข้อมูล",
        payment_of_referral_bonus: "การจ่ายโบนัสการแนะนำจะเกิดขึ้นในสัปดาห์ถัดจากสัปดาห์ที่ผู้ที่ได้รับการแนะนำมีคุณสมบัติครบถ้วน",
        referral_bonus_paid_in_aaafx_wallet: "โบนัสการแนะนำจะจ่ายในกระเป๋าเงิน AAAFx USD ซึ่งผู้แนะนำและผู้ที่ได้รับการแนะนำสามารถถอนหรือโอนไปยังบัญชีการเทรดของพวกเขาได้",
        read_all_terms_conditions: "อ่านข้อกำหนดและเงื่อนไขทั้งหมด",
        here: "ที่นี่",
        contact_us: "มีคำถาม? ติดต่อเราได้ที่แชทสดตลอด 24 ชั่วโมงใน 5 วันต่อสัปดาห์หรือส่งอีเมลถึงเราที่",
        customer_care: "customercare{'@'}aaafx-international.com",
        definitions: "คำจำกัดความ",
        meaning_of_all_above_columns: "นี่คือความหมายของคอลัมน์ด้านบนทั้งหมดสำหรับการอ้างอิงของคุณ:",
        name_of_your_referral: "- ชื่อผู้ที่ได้รับการแนะนำของคุณ",
        meaning_of_various_stages: "- กรุณาดูความหมายของขั้นต่าง ๆ ด้านล่าง",
        registered: "1. ลงทะเบียนแล้ว:",
        registered_link: "ผู้ที่ได้รับการแนะนำของคุณได้ลงทะเบียนโดยใช้ลิงก์ของคุณ",
        funded: "2. ฝากเงินแล้ว:",
        referral_deposited: "ผู้ที่ได้รับการแนะนำของคุณได้ฝากเงิน",
        third_point_qualified: "3. มีคุณสมบัติ:",
        referral_has_deposited: "ผู้ที่ได้รับการแนะนำของคุณได้ฝากเงินและทำการเทรดจนถึงวอลุ่มที่ต้องการ ตอนนี้คุณทั้งคู่มีสิทธิ์ได้รับรางวัล",
        deposits_made_by_referral: "- เงินฝากจากผู้ที่ได้รับการแนะนำของคุณ",
        volume_requirement: "วอลุ่มที่ต้องการ",
        volume_required_for_reward: "- วอลุ่มที่จำเป็นสำหรับผู้ที่ได้รับการแนะนำของคุณเพื่อให้มีสิทธิ์ได้รับรางวัล",
        volume_your_referral_traded: "- วอลุ่มที่ผู้ที่ได้รับการแนะนำของคุณเทรดจริง",
        referral_qualified_for_reward: "- ไม่ว่าผู้ที่ได้รับการแนะนำของคุณจะมีคุณสมบัติตรงตามข้อกำหนดของรางวัลหรือไม่ก็ตาม",
        referral_ib_programs: "หลังจากได้รับรางวัลจากผู้ได้รับการแนะนำ 10 คน คุณสามารถเป็น IB หรือดำเนินการต่อภายใต้โปรแกรมการเชิญเพื่อนและสร้างรายได้ โดยมีรางวัล 20 ดอลลาร์ต่อคนสำหรับคุณและผู้อ้างอิงของคุณ คุณสามารถเปรียบเทียบสิทธิประโยชน์และคุณสมบัติของโปรแกรมชวนเพื่อนและโปรแกรม IB ของเรา"
    },
    calculators_common: {
        asset_class: "ประเภทสินทรัพย์",
        forex: "ฟอเร็กซ์",
        commodities: "สินค้าโภคภัณฑ์",
        indices: "ดัชนี",
        account_base_currency: "สกุลเงินฐานของบัญชี",
        usd: "USD",
        gbp: "GBP",
        aud: "AUD",
        eur: "EUR",
        symbol: "สัญลักษณ์",
        select_symbol: "เลือกสัญลักษณ์",
        trade_size_in_lots: "ขนาดการเทรด (เป็นล็อต)",
        calculate: "คำนวณ"
    },
    margin: {
        margin_required: "มาร์จิ้นที่ต้องการ:",
        maximum_leverage: "Maximum Leverage:"
    },
    pip: {
        pip_value: "มูลค่าพิพ:"
    },
    swap: {
        server: "เซิร์ฟเวอร์",
        mt_four_five: "MT4/MT5",
        act_trader: "Act Trader",
        no_of_days: "จำนวนวัน",
        long_swap: "สวอปแบบยาว:",
        short_swap: "สวอปแบบสั้น:"
    },
    //S
    dashboard:{
        select_trading_id: "เลือกรหัสการเทรด",
        leverage: "เลเวอเรจ",
        balance: "ยอดคงเหลือ",
        equity: "เงินทุน",
        free_margin: "ฟรีมาร์จิ้น",
        pnl: "PNL",
        web_trader : "เว็บเทรดเดอร์",
        fund: "กองทุน",
        promotions: "โปรโมชัน",
        hundred: "100",
        bonus: "โบนัส",
        avail: "ใช้ได้",
        deposit_bonus: "โบนัสเงินฝาก",
        loading_initial_data: "กำลังโหลดข้อมูลเริ่มต้น",
    },
    enable_2fa:{
        title: "การตรวจสอบสิทธิ์ของ Google (2FA)",
        description: "หากต้องการเปิดใช้งานการตรวจสอบสิทธิ์แบบสองปัจจัยของ Google (2FA) ให้สแกนรหัส QR และกรอกรหัสผ่านครั้งเดียวที่สร้างขึ้นด้านล่าง",
        google_authenticator_code: "รหัส Google Authenticator",
        how_to_enable: "ในการเปิดใช้งานการตรวจสอบสิทธิ์แบบ 2 ปัจจัย:",
        download: "ดาวน์โหลด",
        google_authenticator_app: "แอป Google Authenticator",
        on_mobile_tablet: "บนมือถือ/แท็บเล็ตของคุณ",
        scan_the : "สแกน",
        qr_code: "รหัสคิวอาร์",
        appearing_above: "ที่ปรากฏอยู่ด้านบน",
        enter_the: "เข้าสู่",
        passcode: "รหัสผ่าน",
        appers_in_google_auth_app: "ที่ปรากฏในแอป Google Authenticator ของคุณ",
        click_on_the_button: "คลิกที่ปุ่ม",
        click_to_enable: "คลิกเพื่อเปิดใช้งาน",
    },
    account_security:{
        title: "การตรวจสอบสิทธิ์ของ Google (2FA)",
        description: "หากต้องการเปิดใช้งานการตรวจสอบสิทธิ์แบบสองปัจจัยของ Google (2FA) ให้สแกนรหัส QR และกรอกรหัสผ่านครั้งเดียวที่สร้างขึ้นด้านล่าง",
        google_authenticator_code: "รหัส Google Authenticator",
        how_to_enable: "ในการเปิดใช้งานการตรวจสอบสิทธิ์แบบ 2 ปัจจัย:",
        download: "ดาวน์โหลด",
        google_authenticator_app: "แอป Google Authenticator",
        on_mobile_tablet: "บนมือถือ/แท็บเล็ตของคุณ",
        scan_the : "สแกน",
        qr_code: "รหัสคิวอาร์",
        appearing_above: "ที่ปรากฏอยู่ด้านบน",
        enter_the: "เข้าสู่",
        passcode: "รหัสผ่าน",
        appers_in_google_auth_app: "ที่ปรากฏในแอป Google Authenticator ของคุณ",
        click_on_the_button: "คลิกที่ปุ่ม",
        click_to_enable: "คลิกเพื่อเปิดใช้งาน",
    },
    change_pass:{
        success_message:"เปลี่ยนรหัสผ่านของคุณสำเร็จแล้ว",
        ok:"OK",
        change_password: "เปลี่ยนรหัสผ่าน",
        existing_password: "รหัสผ่านที่มีอยู่",
        new_password: "รหัสผ่านใหม่",
        confirm_new_password: "ยืนยันรหัสผ่านใหม่",
        note_one: "รหัสผ่านควรมีตัวอักษรอย่างน้อย 7 ตัวและสูงสุด 10 ตัว และควรมีตัวเลขอย่างน้อย 1 ตัว ตัวอักษรพิมพ์ใหญ่ 1 ตัว และอักขระพิเศษ 1 ตัว {'(!@#$%^)'}",
        note_two: "โปรดทราบว่ารหัสผ่านโปรไฟล์จะแตกต่างจากรหัสผ่านบัญชีการเทรดของคุณ",
        cancel: "ยกเลิก",
    },
    corporate_varify_step_three:{
        please_upload_file: "กรุณาอัปโหลดไฟล์",
        out_of_documents: "จาก 8 เอกสาร",
        add_file: "เพิ่มไฟล์",
        max_file_size: "ขนาดไฟล์สูงสุดที่สามารถอัปโหลดได้สูงสุด"
    },
    corporate_varify:{
        corporation_info: 'ข้อมูลองค์กร',
        account_creation: "การสร้างบัญชี",
        verification: "การยืนยัน",
        deposit: "เงินฝาก",
        select_platform: "เลือกแพลตฟอร์ม",
        select_account_type: "เลือกประเภทบัญชี",
        select_leverage: "เลือกเลเวอเรจ",
        select_base_currency: "เลือกสกุลเงินฐานของบัญชี",
        select_currency: "เลือกสกุลเงิน",
        password: "รหัสผ่าน",
        pass_length_alert: "ความยาวขั้นต่ำของรหัสผ่านคือ 5 ตัวและต้องมีตัวอักษรพิมพ์เล็กอย่างน้อย 1 ตัว ตัวอักษรพิมพ์ใหญ่ 1 ตัว ตัวเลข 1 ตัว และอักขระพิเศษ 1 ตัว",
        of_characters: "ของอักขระ",
        lowercase_letter: 'ตัวอักษรพิมพ์เล็ก',
        capital_letter : "ตัวอักษรพิมพ์ใหญ่",
        number: "หมายเลข",
        special_character : "อักขระพิเศษ",
        confirm_password: "ยืนยันรหัสผ่าน",
        create_account : "สร้างบัญชี",
    },
    corporation_info:{
        name_of_company: "ชื่อของบริษัท",
        country_of_company: "ประเทศของบริษัท",
        select_company_country: "เลือกประเทศของบริษัท",
        registration: "การลงทะเบียน",
        submit: "ส่ง",
    },
    profile:{
        personal_details: "ข้อมูลส่วนตัว",
        uploaded_documents: "เอกสารที่อัปโหลดแล้ว",
        no_documents_yet: "ยังไม่มีเอกสาร",
    },
    questions:{
        financial_details: "รายละเอียดทางการเงิน",
        sub_heading_one: "รายได้ต่อปีโดยประมาณทั้งหมด",
        select_annual_income: "เลือกรายได้ต่อปี",
        sub_heading_two: "รวมมูลค่าสุทธิโดยประมาณ",
        sub_heading_two_desc: "สินทรัพย์รวมลบหนี้สินทั้งหมดของบุคคลหรือบริษัท",
        select_net_worth:"เลือกมูลค่าสุทธิ",
        sub_heading_three: "อุตสาหกรรมอาชีพ",
        select_occupation: "เลือกอาชีพ",
        sub_heading_four: "กรอกอาชีพอื่น",
        sub_heading_five: "แหล่งเงินทุน",
        sub_heading_six: "กรอกแหล่งเงินทุนอื่น",
        sub_heading_seven: "บุคคลที่รายงาน FATCA ของสหรัฐอเมริกา",
        sub_heading_eight: "ประเทศ/เขตอำนาจศาลของถิ่นที่อยู่ภาษี",
        select_residence_country: "เลือกประเทศที่อยู่อาศัย",
        sub_heading_nine: "คุณมีหมายเลข TIN หรือไม่?",
        sub_heading_ten: "กรอกหมายเลข TIN",
        sub_heading_eleven: "หากไม่มี TIN ให้กรอกเหตุผล",
        select_reasons: "เลือกเหตุผล",
        enter_reason: "กรอกเหตุผล",
        submit: "ส่ง",
        dear: "เรียน",
        message_one: "จากข้อมูลที่คุณให้ไว้ ดูเหมือนว่าคุณเป็นผู้มีถิ่นที่อยู่ในสหรัฐอเมริกาเพื่อจุดประสงค์ด้านภาษี",
        message_two: "โปรดทราบว่าเนื่องจากการปฏิบัติตามกฎข้อบังคับของเรา AAAFx จึงไม่สามารถรับลูกค้าที่มีถิ่นที่อยู่ในสหรัฐอเมริกาเพื่อจุดประสงค์ด้านภาษีได้",
        message_three: "เราขอขอบคุณล่วงหน้าที่คุณเข้าใจ",
        message_four: "ขอแสดงความนับถือ",
        message_five: "AAAFx",
        close: "ปิด",
    },
    verify:{
        account_creation: "การสร้างบัญชี",
        financial_details: "รายละเอียดทางการเงิน",
        verification: "การยืนยัน",
        deposit: "เงินฝาก",
        select_platform: "เลือกแพลตฟอร์ม",
        select_account_type: "เลือกประเภทบัญชี",
        select_leverage: "เลือกเลเวอเรจ",
        select_base_currency: "เลือกสกุลเงินฐานของบัญชี",
        select_currency: "เลือกสกุลเงิน",
        password: "รหัสผ่าน",
        pass_message_one: "ความยาวขั้นต่ำของรหัสผ่านคือ 5 ตัวและต้องมีตัวอักษรพิมพ์เล็กอย่างน้อย 1 ตัว ตัวอักษรพิมพ์ใหญ่ 1 ตัว ตัวเลข 1 ตัว และอักขระพิเศษ 1 ตัว",
        pass_message_two: "ความยาวขั้นต่ำของรหัสผ่านคือ 8 ตัวและต้องมีอักษรตัวพิมพ์เล็กอย่างน้อย 1 ตัว ตัวพิมพ์ใหญ่ 1 ตัว ตัวเลข 1 ตัว และอักขระพิเศษ 1 ตัว",
        of_characters: "ของอักขระ",
        lowercase_letter: "ตัวอักษรพิมพ์เล็ก",
        capital_letter: "ตัวอักษรพิมพ์ใหญ่",
        number: "หมายเลข",
        special_character: "อักขระพิเศษ",
        confirm_password: "ยืนยันรหัสผ่าน",
        create_account: "สร้างบัญชี",
        doc_message_one: "เอกสารที่คุณส่งถูกปฏิเสธโดยกระบวนการตรวจสอบอัตโนมัติ มีการสร้างตั๋วที่เกี่ยวข้องซึ่งคุณสามารถอัปโหลดเอกสารของคุณใหม่เพื่อให้เราตรวจสอบเอกสารด้วยตนเองได้หากต้องการ",
        view_ticket: "ดูตั๋ว",
    },
    verify_quest_bkp:{
        account_creation: "การสร้างบัญชี",
        questionnaire: "แบบสอบถาม",
        verification: "การยืนยัน",
        deposit:"Deposit",
        select_platform: "เลือกแพลตฟอร์ม",
        select_account_type: "เลือกประเภทบัญชี",
        select_leverage: "เลือกเลเวอเรจ",
        select_base_currency: "เลือกสกุลเงินฐานของบัญชี",
        select_currency: "เลือกสกุลเงิน",
        password: "รหัสผ่าน",
        pass_length_alert: "ความยาวขั้นต่ำของรหัสผ่านคือ 5 ตัวและต้องมีตัวอักษรพิมพ์เล็กอย่างน้อย 1 ตัว ตัวอักษรพิมพ์ใหญ่ 1 ตัว ตัวเลข 1 ตัว และอักขระพิเศษ 1 ตัว",
        of_characters: "ของอักขระ",
        lowercase_letter: "ตัวอักษรพิมพ์เล็ก",
        capital_letter: "ตัวอักษรพิมพ์ใหญ่",
        number: "หมายเลข",
        special_character: "อักขระพิเศษ",
        confirm_password: "ยืนยันรหัสผ่าน",
        create_account: "สร้างบัญชี",
        doc_message_one: "เอกสารที่คุณส่งถูกปฏิเสธโดยกระบวนการตรวจสอบอัตโนมัติ มีการสร้างตั๋วที่เกี่ยวข้องซึ่งคุณสามารถอัปโหลดเอกสารของคุณใหม่เพื่อให้เราตรวจสอบเอกสารด้วยตนเองได้หากต้องการ",
        view_ticket: "ดูตั๋ว",
    },
    close_ticket:{
        heading: "ตั๋วที่ปิดแล้ว",
        create_request: "สร้างคำขอ",
        open_tickets: "ตั๋วที่เปิดอยู่",
        ticket_number: "หมายเลขตั๋ว",
        trading_id: "รหัสการเทรด",
        status: "สถานะ",
        subject: "เรื่อง",
        created: "สร้างแล้ว",
        closed: "ถูกปิด",
        action: "การดำเนินการ",
        view_ticket: "ดูตั๋ว",
        no_tickets_found: "ไม่พบตั๋ว",
    },
    open_ticket:{
        heading: "เปิดตั๋ว",
        create_request: "สร้างคำขอ",
        open_tickets: "ตั๋วที่เปิดอยู่",
        closed_ticket: "ตั๋วที่ปิดแล้ว",
        ticket_number: "หมายเลขตั๋ว",
        trading_id: "รหัสการเทรด",
        status: "สถานะ",
        subject: "เรื่อง",
        created: "สร้างแล้ว",
        action: "การดำเนินการ",
        view_ticket: "ดูตั๋ว",
        no_tickets_found: "ไม่พบตั๋ว",
    },
    request_call:{
        success_message:"ได้รับคำขอให้โทรกลับของคุณแล้ว ทีมงานของเราจะติดต่อคุณในไม่ช้า",
        ok: "ตกลง",
        request_call_back:"ส่งคำขอให้โทรกลับ",
        first_name: "ชื่อจริง",
        last_name: "นามสกุล",
        email_id: "รหัสอีเมล",
        phone_number: "หมายเลขโทรศัพท์",
        timezone: "โซนเวลา",
        date: "วันที่",
        preferred_time: "เวลาที่ต้องการ",
        department: "แผนก",
        select_department: "เลือกแผนก",
        new_accounts: "บัญชีใหม่",
        deposits: "เงินฝาก",
        withdrawals: "ถอนเงิน",
        partnership: "หุ้นส่วน",
        technical_support: "การสนับสนุนทางเทคนิค",
        message: "ข้อความ",
        send_request: "ส่งคำขอ",
    },
    support_page:{
        success_message:"สร้างตั๋วสนับสนุนสำหรับคุณเรียบร้อยแล้ว คุณสามารถติดตามได้ที่ ตั๋วที่เปิดอยู่",
        ok:"ตกลง",
        support: "สนับสนุน",
        create_req:"สร้างคำขอ",
        open_tickets:"ตั๋วที่เปิดอยู่",
        closed_tickets: "ตั๋วที่ถูกปิด",
        otp_msg:"เราได้ส่ง OTP ไปยังอีเมลที่คุณลงทะเบียนแล้ว กรุณาป้อนเพื่อยืนยันคำขอตั๋วสนับสนุน",
        otp: "OTP",
        submit: "ส่ง",
        reason: "เหตุผล",
        select_a_reason: "เลือกเหตุผล",
        trading_id: "รหัสการเทรด",
        select_trading_account: "เลือกบัญชีการเทรด",
        subject: "เรื่อง",
        trade_order_id: "รหัสคำสั่งเทรด",
        time_of_trade_opening: "เวลาในการเปิดการเทรด",
        time_of_trade_closing: "เวลาในการปิดการเทรด",
        instrument_traded: "เทรดตราสาร",
        type_of_trade: "ประเภทการเทรด",
        select_trade_type: "เลือกประเภทการเทรด",
        details_of_the_issue: "รายละเอียดของปัญหา",
        refund_claim_amount: "จำนวนเงินที่ขอคืน",
        message: "ข้อความ",
        note: "หมายเหตุ",
        file_attachments: "ไฟล์แนบ",
        file_size_msg: "ขนาดของเอกสารไม่ควรเกิน 1MB",
        file_format_msg: "รูปแบบไฟล์ (jpeg หรือ pdf) เท่านั้น",
        lowercase_note: "หมายเหตุ",
        note_desc: "ในกรณีที่เกิดข้อผิดพลาดขณะดำเนินการบัญชี กรุณาแนบภาพหน้าจอไปด้วยขณะสร้างตั๋ว",
        create_support_request: "สร้างคำขอการสนับสนุน",
    },
    become_ib:{
        heading: "แนะนำโบรกเกอร์",
        description: "เพิ่มรายได้ของคุณด้วยโปรแกรม IB ของเรา <br /> รับลิงก์เฉพาะของคุณ แชร์กับเพื่อนของคุณ และรับค่าคอมมิชชันเมื่อใดก็ตามที่พวกเขาเทรด",
        sub_heading: "เราเสนอโปรแกรม IB สองประเภท:",
        point_one: "โปรแกรม IB มาตรฐาน - รับทันที 20% ของรายได้ค่าคอมมิชชันจากลูกค้าของคุณ สิ่งนี้มีประโยชน์สำหรับ IB มือใหม่ที่ต้องการเริ่มต้นใหม่หรือสามารถเริ่มนำลูกค้าในจำนวนที่จำกัดมาให้เรา",
        point_two: "โปรแกรม IB ขั้นสูง - นี่คือโปรแกรม IB ที่ให้ผลตอบแทนสูงและกำหนดเองสำหรับ IB ที่ใหญ่กว่าของเรา สิ่งนี้มีประโยชน์สำหรับบุคคลที่มีฐานลูกค้าจำนวนมากซึ่งสามารถนำเข้าวอลุ่มที่มากขึ้นได้",
        note_one: "คุณสามารถย้ายจากโปรแกรม IB มาตรฐานไปยังโปรแกรม IB ขั้นสูงได้ เมื่อคุณสร้างเครือข่ายของคุณให้ใหญ่มากพอแล้ว",
        earn_with: "สร้างรายได้",
        zero_investment_or: "โดยไม่ต้องลงทุนหรือ",
        experience: "ไม่ต้องมีประสบการณ์",
        weekly_ib: "IB รายสัปดาห์",
        commissions: "การจ่าย",
        payouts: "ค่าคอมมิชชัน",
        unlimited: "ศักยภาพ",
        earnings: "การสร้างรายได้",
        potential: "ที่ไม่จำกัด",
        sub_cont_point_four: "โปรแกรม IB ขั้นสูงที่ได้รับการปรับแต่งและให้รางวัลสูง",
        ultra_fast: "การถอนเงิน",
        withdrawals_of_ib: "ค่าคอมมิชชัน IB",
        commission: "ที่รวดเร็วอย่างมาก",
        easy_user: "อินเตอร์เฟซ",
        interface_of: "พอร์ทัล IB",
        ib_portal: "ที่ใช้งานง่าย",
        dedicated: "บัญชี",
        account: "เฉพาะ",
        manager: "ผู้จัดการ",
        helpful_and: "เอกสารประกอบ",
        free_marketing: "ด้านการตลาด",
        material: "ที่ฟรีและมีประโยชน์",
        become_an_ib: "มาเป็น IB",
    },
    pamm_acct:{
        title:"บัญชี PAMM",
        description_one: "PAMM (โมดูลการจัดการการจัดสรรเปอร์เซ็นต์) เป็นบัญชีการจัดการที่ผู้จัดการดำเนินการเทรดในบัญชีย่อยทั้งหมด ผู้จัดการและนักลงทุนมีอิสระในการเลือกโครงสร้างค่าธรรมเนียมการปฏิบัติงาน และเราจะดูแลให้เป็นไปตามนั้น",
        description_two: "AAAFx ให้บริการโซลูชันการเทรด PAMM ที่มีความยืดหยุ่นสูงและปรับแต่งได้",
        sub_title: "วิธีลงทะเบียนเป็นผู้จัดการ PAMM",
        sub_Point_one: "บัญชีผู้จัดการ PAMM ของคุณสามารถเปิดได้เมื่อคุณมีนักลงทุนอย่างน้อยสี่รายที่มีเงินฝากรวม 5,000 ดอลลาร์ขึ้นไป",
        sub_Point_two: "เพียงลงทะเบียนเป็น IB เพื่อเป็นผู้จัดการ PAMM กับเรา ให้ลูกค้าของคุณลงทะเบียนโดยใช้ลิงก์ IB ของคุณ ปฏิบัติตามเงื่อนไขข้อแรกด้านบน",
        sub_Point_three: "ติดต่อเราผ่านทางแชทสดหรือส่งอีเมลถึงเราที่",
        sub_Point_four: "เริ่มรับค่าคอมมิชชัน IB นอกเหนือจากค่าธรรมเนียมการปฏิบัติงานของ PAMM",
        minimul_investment: "การลงทุนขั้นต่ำ",
        ease_of_access: "ความง่ายในการเข้าถึง",
        ultimate_trading_conditions: "เงื่อนไขการเทรดที่ดีที่สุด",
        trade_security: "การรักษาความปลอดภัยในการเทรด",
        request_pamm: "ขอ PAMM",
    },
    add_payment_methods:{
        success_message: "เพิ่มวิธีการชำระเงินของคุณเรียบร้อยแล้ว คุณสามารถติดตามได้ที่ ตั๋วที่เปิดอยู่",
        ok: "ตกลง",
        otp_message: "เราได้ส่ง OTP ไปยังอีเมลที่คุณลงทะเบียนแล้ว กรุณากรอกเพื่อยืนยันคำขอตั๋วสนับสนุน",
        otp: "OTP",
        submit: "ส่ง",
        page_heading: "เพิ่มวิธีการชำระเงิน",
        select_payment_method: "เลือกวิธีการชำระเงิน",
        select_method: "เลือกวิธีการ",
        bank: "ธนาคาร",
        credit_card: "บัตรเครดิต",
        crypto: "คริปโต",
        select_crypto_currency: "เลือกสกุลเงินดิจิทัล",
        select_crypto: "เลือกคริปโต",
        btc: "BTC",
        eth: "ETH",
        usdt: "USDT",
        usdc: "USDC",
        add_your_bank_details: "เพิ่มรายละเอียดธนาคารของคุณ",
        bank_name: "ชื่อธนาคาร",
        account_name: "ชื่อบัญชี",
        account_number: "หมายเลขบัญชี",
        country: "ประเทศ",
        select_country: "เลือกประเทศ",
        iban: "IBAN",
        iban_note: "ธนาคารของฉันไม่ออก IBAN",
        swift: "Swift",
        bic: "BIC",
        sort_code: "รหัสจัดเรียง",
        bank_address: "ที่อยู่ธนาคาร",
        upload_your_bank_statement: "อัปโหลดรายการเงินฝากถอนในบัญชีธนาคารของคุณ",
        upload_doc_info_one: "ขนาดของเอกสารไม่ควรเกิน 1MB",
        upload_doc_info_two: "รูปแบบไฟล์ (jpeg หรือ pdf) เท่านั้น",
        note: "หมายเหตุ",
        note_msg: "ในกรณีที่เกิดข้อผิดพลาดขณะดำเนินการบัญชี กรุณาแนบภาพหน้าจอไปด้วยขณะสร้างตั๋ว",
        create_support_request: 'สร้างคำขอการสนับสนุน',
        add_your_card_details: "เพิ่มรายละเอียดบัตรของคุณ",
        creadit_card_number: "หมายเลขบัตรเครดิต",
        month: "เดือน",
        zero_one: "01",
        zero_two: "02",
        zero_three: "03",
        zero_four: "04",
        zero_five: "05",
        zero_six: "06",
        zero_seven: "07",
        zero_eight: "08",
        zero_nine: "09",
        ten: "10",
        eleven: "11",
        twelve: "12",
        year: "ปี",
        two_thousand_twenty: "2020",
        two_thousand_twentyone: "2021",
        two_thousand_twentytwo: "2022",
        two_thousand_twentytree: "2023",
        two_thousand_twentyfour: "2024",
        two_thousand_twentyfive: "2025",
        two_thousand_twentysix: "2026",
        two_thousand_twentyseven: "2027",
        two_thousand_twentyeight: "2028",
        two_thousand_twentynine: "2029",
        two_thousand_thirty: "2030",
        cvv: "CVV",
        varification_msg: "เราต้องการสิ่งต่อไปนี้สำหรับการยืนยันบัตร",
        varification_msg_one: "สำเนาสีด้านหน้าบัตร แสดงชื่อนามสกุล วันหมดอายุ ชื่อธนาคาร/โลโก้ 4 หลักแรกและ 4 หลักสุดท้ายของหมายเลขบัตรเครดิตซ่อน 8 หลักตรงกลาง",
        upload_supporting_document: "อัปโหลดเอกสารสนับสนุน",
        varification_msg_two: "สำเนาสีของด้านหลังของบัตรที่ซ่อนรหัสความปลอดภัย CVV สำเนาด้านหลังควรแสดงเครื่องหมายของผู้ถือบัตร",
        add_selected_crypto_address: "เพิ่มที่อยู่คริปโตที่เลือก",
        address: "ที่อยู่",
    },
    deposit:{
        account_type: "ประเภทบัญชี",
        select_type: "เลือกประเภท",
        live: "สด",
        trading_account: "บัญชีการเทรด",
        select_trading_account: "เลือกบัญชีการเทรด",
        balance: "ยอดคงเหลือ",
        fund: "กองทุน",
        amount: "จำนวน",
        region: "ภูมิภาค",
        currencies: "สกุลเงิน",
        processing_time: "ระยะเวลาดำเนินการ",
        action: "การดำเนินการ",
        view_more: "ดูเพิ่มเติม",
        currency: "สกุลเงิน",
        zar: "ZAR",
        swift_code: "Swift Code",
        beneficiarys_name: "ชื่อผู้รับผลประโยชน์",
        beneficiarys_name_des: "SIKHULA VENTURE CAPITAL (PTY) LTD",
        account_number: "หมายเลขบัญชี",
        user_account_number: "62928423269",
        bank_address: "ที่อยู่ธนาคาร",
        bank_address_info: "Mybranch Forum 1, 4th Fl, 33 Hoofd Str, Braampark",
        dixipay: "Dixipay",
        bank_name: "ชื่อธนาคาร",
        bank_name_info: "DIXIPAY LTD",
        swift_code_info: "DIXPGB21",
        beneficiarys_name_info: 'Alpha Global Limited',
        iban: "IBAN",
        iban_no: "GB78DIXP00997890200462",
        eur: "EUR",
        city: "เมือง",
        city_info: "ลอนดอน",
        country: "ประเทศ",
        country_info: "สหราชอาณาจักร",
        dixipay_note: "Dixipay รับเฉพาะเงินฝากเท่านั้น ในสกุลเงิน EURO",
        you_can_deposit: "คุณสามารถฝากเงิน",
        you_can_deposit_msg: "ในที่อยู่ต่อไปนี้และจำนวนเงินที่เทียบเท่าในสกุลเงินของบัญชีที่เลือกจะถูกเพิ่มหลังจากการแปลง",
        copy: "คัดลอก",
        done: "เสร็จสิ้น",
        network_msg: "รองรับเครือข่าย ERC-20 (USDT, USDC, ETH) การใช้เครือข่ายอื่นจะไม่ถึงจุดสิ้นสุดของเรา",
    },
    fund_index: {
        add_funds: "เพิ่มกองทุน",
        cancel: "ยกเลิก",
        ok: "ตกลง",
        your_request_to_add: "คำขอของคุณที่จะเพิ่ม",
        to_your_demo_account_number: "ไปยังหมายเลขบัญชีทดลองของคุณ",
        has_been_successfully_completed: "เสร็จเรียบร้อยแล้ว",
        your_request_to_withdraw: "คำขอถอนเงินของคุณ",
        from_the_trading_id: "จากรหัสการเทรด",
        has_been_received: "ได้รับการตอบรับ",
        click_to_proceed_withdrawal: "กรุณาคลิกที่ลิงก์ยืนยันที่ส่งไปยังอีเมลที่ลงทะเบียนของคุณเพื่อดำเนินการถอนเงิน",
        has_been_successfully: "สำเร็จเรียบร้อย",
        your_request_to_add_usd: "คำขอของคุณที่จะเพิ่ม USD",
    },
    request_verify: {
        verifying_your_request: "กำลังตรวจสอบคำขอของคุณ",
        success: "สำเร็จ",
        go_to_transactions: "ไปที่ธุรกรรม",
        error: "ข้อผิดพลาด",
    },
    transactions: {
        list_of_transactions: "รายการธุรกรรม",
        deposits: "เงินฝาก",
        withdrawals: "ถอนเงิน",
        bonus: "โบนัส",
        deposit_transactions: "การทำธุรกรรมเงินฝาก",
        filter_by: "กรองตาม",
        select_trading_id: "เลือกรหัสการเทรด",
        all: "ทั้งหมด",
        date: "วันที่",
        account_id: 'รหัสบัญชี',
        currency: "สกุลเงิน",
        payment_mode: "โหมดการชำระเงิน",
        deposit_amount: "จำนวนเงินฝาก",
        status: 'สถานะ',
        no_deposits_yet: "ยังไม่มีเงินฝาก",
        withdrawal_mode: "โหมดการถอนเงิน",
        withdrawal_amount: "จำนวนเงินที่ถอนออก",
        action: "การดำเนินการ",
        view_more : "ดูเพิ่มเติม",
        no_withdrawals_yet: "ยังไม่มีการถอนเงินออก",
        bonus_amount: "จำนวนโบนัส",
        pending : "รอดำเนินการ",
        no_bonus_transactions_yet: "ยังไม่มีธุรกรรมโบนัส",
        deposit_currency: "สกุลเงินฝาก",
        account_currency: 'สกุลเงินบัญชี',
        address: 'ที่อยู่',
    },
    withdrawal: {
        kyc_req_msg: "จำเป็นต้องกรอก KYC ก่อนขอถอนเงิน กรุณาส่งหลักฐานที่อยู่โดยใช้ตั๋วสนับสนุน",
        Click_here: "คลิกที่นี่",
        or_email_to: 'หรือส่งอีเมลไปที่',
        with_step_heading: "หลักฐานยืนยันที่อยู่ต่อไปนี้ได้รับการยอมรับ",
        one: "1",
        two: "2",
        three: "3",
        with_step_one: "บิลค่าสาธารณูปโภค",
        with_step_two: "รายการเงินฝากถอนในบัญชี",
        with_step_three: "เอกสารภาษีที่ออกโดยรัฐบาล",
        note: "หมายเหตุ",
        note_info: "หลักฐานแสดงที่อยู่จะต้องมีอายุไม่เกิน 4 เดือน",
        ok: "ตกลง",
        enable_2fa_msg: "จำเป็นต้องเปิดใช้งาน 2FA เพื่อส่งคำขอถอนเงิน กรุณาคลิกที่ปุ่มต่อไปนี้",
        click_to_enable: "คลิกเพื่อเปิดใช้งาน",
        select_trading_id: "เลือกรหัสการเทรด",
        account_id: "รหัสบัญชี",
        account_type: "ประเภทบัญชี",
        platform: 'แพลตฟอร์ม',
        leverage: "เลเวอเรจ",
        currency: "สกุลเงิน",
        free_margin: "ฟรีมาร์จิ้น",
        note_info_two: "กรอกจำนวนเงินที่ถอนในสกุลเงินฐานของบัญชีการเทรดของคุณ",
        amount: "จำนวน",
        mode_of_payment: "โหมดการชำระเงิน",
        create_transaction: "สร้างธุรกรรม",
        cancel: "ยกเลิก",
        add_payment_method: "เพิ่มวิธีการชำระเงิน",
        no_amount_available: "ไม่มีจำนวนเงินในบัญชีนี้",
    },
    //components -> Shared
    account_dropdown:{
        select_account: "เลือกบัญชี",
    },
    footer: {
        legal_information: "ข้อมูลทางกฎหมาย",
        legal_information_info: "Sikhula Venture Capital (Pty) Ltd. ได้รับอนุญาตและกำกับดูแลโดย South African Financial Sector Conduct Authority (FSCA เลขที่ 2017/315029/07)",
        risk_warning: "คำเตือนความเสี่ยง",
        risk_warning_info: `การเทรดสกุลเงินสปอตนั้นมีความเสี่ยงสูงและมีโอกาสขาดทุนอยู่เสมอ ผลการเทรดของคุณอาจแตกต่างกันไป เนื่องจากปัจจัยเสี่ยงมีสูงในการเทรดในตลาดแลกเปลี่ยนเงินตราต่างประเทศ จึงควรใช้เฉพาะกองทุนที่ "มีความเสี่ยง" อย่างแท้จริงเท่านั้นในการเทรดดังกล่าว หากคุณไม่มีเงินทุนเพิ่มเติมที่คุณสามารถจะสูญเสียได้ คุณไม่ควรเทรดในตลาดแลกเปลี่ยนเงินตราต่างประเทศ ไม่เคยมีการสร้างระบบการเทรดที่ "ปลอดภัย" และไม่มีใครสามารถรับประกันผลกำไรหรืออิสระจากการขาดทุน`,
    },
    header: {
        welcome: "ยินดีต้อนรับ", 
        profile: 'Profile',
        request_callback: "คำขอโทรกลับ",
        support_ticket: "ตั๋วสนับสนุน",
        change_password: "เปลี่ยนรหัสผ่าน",
        logout: "ออกจากระบบ",
    },
    pagination: {
        total_records: "บันทึกทั้งหมด", 
    },
    side_bar: {
        dashboard: "แผงควบคุม",
        manage_accounts: "จัดการบัญชี",
        fund: "กองทุน",
        bonus: "โบนัส",
        become_a_partner: "ร่วมเป็นพันธมิตร",
        tools: "เครื่องมือ",
        bonus_and_promotions: 'โบนัสและโปรโมชัน',
    },
    success_box: {
        otp_varify: "กรุณากรอกรหัสพินแบบใช้ครั้งเดียว 6 หลักที่แสดงในแอป Google Authenticator",
        cancel: "ยกเลิก",
        submit: 'Submit',
        trouble_with_2fa: "มีปัญหากับรหัสการยืนยันตัวตนแบบสองปัจจัยของคุณใช่หรือไม่?",
        click_varify_with_email: "คลิกที่นี่เพื่อยืนยันด้วยอีเมล",
        or: "หรือ",
        click_here: "คลิกที่นี่",
        to_enable_2fa: "เพื่อเปิดใช้งาน 2FA ของคุณและดำเนินการตามคำขอของคุณ",
        take_me_back: "พาฉันกลับไป",
    },
    tost_message: {
        varify_acc: "กรุณายืนยันบัญชีของคุณเพื่อสร้างบัญชีจริง",
        click_to_begin: "คลิกเพื่อเริ่มกระบวนการยืนยัน",
    },
    proof_residence_alert: {
        you_have: "คุณมี",
        days_left_for_proof: "วันที่เหลือในการยื่นหลักฐานแสดงถิ่นที่อยู่อาศัย",
        click_here: "คลิกที่นี่",
        to_upload: "ที่จะอัปโหลด",
    },
    closed_trades: {
        login: "เข้าสู่ระบบ",
        order: "คำสั่งซื้อ",
        symbol: "สัญลักษณ์",
        volume: "วอลุ่ม",
        open_price: "ราคาเปิด",
        open_time: "เวลาเปิด",
        commission: "คอมมิชชัน",
        type: 'ประเภท',
        sl: "SL",
        tp: "TP",
        close_price: 'ราคาปิด',
        close_time: 'เวลาปิด',
        swap: 'สวอบ',
        pnl: "PNL",
        comment: 'ความคิดเห็น',
        no_record_found: "ไม่พบบันทึก",
    },
    open_trade: {
        order: 'คำสั่งซื้อ',
        symbol: 'สัญลักษณ์',
        type: 'ประเภท',
        volume: "วอลุ่ม",
        open_price: "ราคาเปิด",
        pnl: "PNL",
        no_record_found: "ไม่พบบันทึก",
    },
}